export const SET_TEMPORARY = 'SERVICES/TEMPORARY/SET_TEMPORARY';
